<template>
    <tr>
        <td style="text-align:center">            
            <v-select
                v-model="itemModel.subject_id"                
                :items="subjects"
                item-value="id"
                outlined
                dense
                hide-details
                @change="updateRecord"
                :disabled="!editTermReports" 
            >
                <template 
                    v-slot:selection="{item}"                                       
                >
                   <span style="font-size:0.8rem; width:40px; text-align:center">{{ item.id }}</span>
                </template>

                <template
                    v-slot:item="data"
                > 
                    {{ data.item.id}} {{ data.item.title }}
                </template>
            </v-select>
        </td>
        <td>{{ itemModel.abbr}}</td>
        <td 
            style="text-align:center"
        >
            <v-text-field
                v-model="itemModel.course_mark"
                hide-details                
                type="number"
                outlined
                style="font-size:0.8rem"
                @blur="updateRecord"
                :disabled="!editTermReports" 
            ></v-text-field>
        </td>        
        <td 
            style="text-align:center"
        >
            <v-text-field
                v-model="itemModel.exam_mark"
                hide-details                
                type="number"
                outlined
                style="font-size:0.8rem"
                @blur="updateRecord"
                :disabled="!editTermReports" 
            ></v-text-field>
        </td>
       
        <td 
            style="max-width: 1px; white-space: nowrap; overflow:hidden; text-overflow: ellipsis;"
        >            
            <v-select
                v-model="itemModel.coded_comment"                
                :items="codedComments1"
                item-value="id"
                outlined
                dense
                hide-details
                @change="updateRecord"
                :disabled="!editTermReports"  
            >
                <template 
                    v-slot:selection="{item}"                                       
                >
                   <span style="font-size:0.8rem; width:40px; text-align:center">{{ item.id }}</span>
                </template>

                <template
                    v-slot:item="data"
                > 
                    {{ data.item.id}} {{ data.item.detail }}
                </template>
            </v-select>                                   
        </td>
        <td 
            style="max-width: 1px; white-space: nowrap; overflow:hidden; text-overflow: ellipsis;"
        >
            <v-select
                v-model="itemModel.coded_comment_1"                
                :items="codedComments1"
                item-value="id"
                outlined
                dense
                hide-details
                @change="updateRecord"
                :disabled="!editTermReports"  
            >
                <template 
                    v-slot:selection="{item}"                                       
                >
                   <span style="font-size:0.8rem; width:40px; text-align:center">{{ item.id }}</span>
                </template>

                <template
                    v-slot:item="data"
                > 
                    {{ data.item.id}} {{ data.item.detail }}
                </template>
            </v-select>                               
        </td>
        
        <td>
            <v-btn 
                icon
                @click="deleteRecord"
                :disabled="!editTermReports" 
            >
                <v-icon
                    small
                >
                    mdi-delete
                </v-icon>
            </v-btn>
        </td>        
    </tr>    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    props: {
        item: Object,
        formLevel: Number,
        term: Number,
        comments1: Array,
        comments2: Array,
    },
    
    mounted: function () { 
        // 
    },

    data: function(){
        return {
            codedComments1: this.comments1,
            codedComments2: this.comments2,
        }
    },

    computed: {
        ...mapGetters({
            subjects: 'admin/getSubjects',
            admin: 'auth/getAdmin', 
            editTermReports: 'admin/getEditTermReports',  
                
        }),

        itemModel () {
            return {...this.item};
        },
    },    

    methods: {
        ...mapActions({
            postTable2Record: 'admin/postUpdateTable2',
            getTable2Records: 'termReports/getTable2Records',
        }),

        ...mapMutations({
            setTable2Record: 'admin/setSelectedTable2Record',           
            setTable2Records: 'termReports/setEditViewTermReportsTable2Records',
            setStudentSubjects: 'termReports/setEditViewTermReportsStudentSubjects',
            setSnackbar: 'admin/setSnackbar',
            setDialogDelete: 'admin/setDialogDelete',
            setSaveStatus: 'termReports/setEditViewTermReportsSaveStatus',
            setSaving: 'termReports/setEditViewTermReportsSaving',
            setSaveError: 'termReports/setEditViewTermReportsSaveError',
            setSaved: 'termReports/setEditViewTermReportsSaved',
        }),

        async updateRecord () { 
            // this.overlay(true);
            // this.loading(true);
            this.setSaving(true);
            this.setSaveStatus("Updating Record");
            this.setSaved(false);
            this.setSaveError(false);

            let table2Record = Object.assign({}, this.itemModel);
            table2Record.subject_id_old = this.item.subject_id;
            table2Record.subject_id_new = this.itemModel.subject_id;
            this.setTable2Record(table2Record);
            try {
                let response = await this.postTable2Record();
                this.$emit('update-average');

                response = await this.getTable2Records();
                this.setTable2Records(response.data.table2_records);
                this.setStudentSubjects(response.data.student_subjects);

                this.setSaving(false);
                this.setSaveStatus("Record Updated");
                this.setSaved(true);
                this.setSaveError(false);

                this.setSnackbar({
                    text: `Record Updated`,
                    display: true,
                    color: 'primary',
                }); 

            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.setSnackbar({
                    text: `Error occured`,
                    display: true,
                    color: 'red',
                });
                
                this.setSaving(false);
                this.setSaveStatus("Error Occured!");
                this.setSaved(false);
                this.setSaveError(true);
            }

            // this.overlay(false);
            // this.loading(false);
        },

        deleteRecord () {
            // console.log(`Delete ${this.itemModel.abbr}`);
            // console.log(this.item);
            this.setDialogDelete({
                display: true,
                text: `Delete ${this.itemModel.title} ?`,
                cancel: true,
                deleteSubject: true,
                deleteStudent: false,
                ok: false
            })            
            this.setTable2Record(this.item);
            
        },
        
    }
}
</script>

<style scoped>
     

    ::v-deep .v-select__slot{
        height: 20px;
    }

    ::v-deep .v-input__icon{
        height: 5px;
        min-width: 8px;
        width: 8px;
    }

    ::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections{
        height: 20px;
        padding: 0px;
    }

    ::v-deep .v-input input{
        max-height: 20px;
    }

    ::v-deep .v-btn--icon.v-size--default{
        height: 20px;
        width: 20px;
    }

    
</style>